import Vue from 'vue'
import Vuex from 'vuex'
import mixins from '@/assets/mixins'
// import VueResource from 'vue-resource';

Vue.use(Vuex)
// Vue.use(VueResource)

// Import axios
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default new Vuex.Store({
  mixins: [mixins],
  state: {
    ufs: null, // Lista de ufs
    municipios: null, // Lista de municipios
    municipiosNascimento: null, // Lista de municipios para nascimento
    loading: false,
    loadingSave: false,
    alert: {
      show: false,
      title: '',
      message: '',
      type: 'error', // success, error, warning, info
      timeout: 5000,
      callback: null
    }
  },
  mutations: {
    "set-ufs"(state, ufs) {
      state.ufs = mixins.methods.orderStr(ufs, 'sigla');
    },
    "set-municipios"(state, municipios) {
      state.municipios = mixins.methods.orderStr(municipios, 'nome');
      state.municipiosNascimento = mixins.methods.orderStr(municipios, 'nome');
    },
    "set-loading"(state, loading) {
      state.loading = loading;
    },
    "set-loading-save"(state, loading) {
      state.loadingSave = loading;
    },
    "set-alert"(state, alert) {
      state.alert = { ...state.alert, ...alert };
    }
  },
  actions: {
    async 'load-ufs'(context) {
      try {
        const response = await Vue.axios.get('/public/estados.json');
        if (response.status === 200) {
          context.commit("set-ufs", response.data);

          return response.data;
        } else {
          alert('Erro ao carregar as uf\'s');
        }
      } catch (error) {
        console.error('Erro ao carregar as uf\'s', error);
      }
    },
    async 'load-municipios'(context) {
      try {
        const response = await Vue.axios.get('/public/municipios.json');
        if (response.status === 200) {
          context.commit("set-municipios", response.data);
        } else {
          alert('Erro ao carregar os municípios');
        }
      } catch (error) {
        console.error('Erro ao carregar os municípios', error);
      }
    },
    'change-loading'(context, value) {
      context.commit("set-loading", value);
    },
    'change-loading-save'(context, value) {
      context.commit("set-loading-save", value);
    },
    'change-alert'(context, value) {
      context.commit("set-alert", value);
    },
    'change-alert-callback'(context, value) {
      // verifica se tem callback
      if (context.state.alert.callback) {
        // chama o callback
        context.state.alert.callback();
      }

      value.callback = null;
      context.commit("set-alert", value);
    }
  },
  modules: {
  }
})
